/**
 * Ordered list of pathname prefix -> docs slug mappings.
 * Checked in order, first match wins, so more specific routes must come
 * before their more generic parents (e.g. settings/billing before settings).
 * A trailing slash (e.g. "/members/") matches only nested/dynamic segments
 * (like a member or event uuid), letting it act as a "detail page" catch-all
 * without also matching sibling static routes checked earlier.
 */
const ROUTE_TO_DOCS_SLUG: Array<{ prefix: string; slug: string }> = [
  // Organization settings
  {
    prefix: "/organization-settings/billing",
    slug: "mimber-organization/settings/billing",
  },
  {
    prefix: "/organization-settings/general",
    slug: "mimber-organization/settings/general-settings",
  },
  {
    prefix: "/organization-settings/organization-profile",
    slug: "mimber-organization/settings/organization-profile",
  },
  {
    prefix: "/organization-settings/roles-permissions",
    slug: "mimber-organization/settings/roles-permissions",
  },
  { prefix: "/organization-settings", slug: "mimber-organization/settings" },

  // Communication
  {
    prefix: "/communication/announcements",
    slug: "mimber-organization/communication/announcements",
  },
  {
    prefix: "/communication/templates",
    slug: "mimber-organization/communication/templates",
  },
  { prefix: "/communication", slug: "mimber-organization/communication" },

  // Events
  {
    prefix: "/events/all-events",
    slug: "mimber-organization/events/all-events",
  },
  {
    prefix: "/events/attendance",
    slug: "mimber-organization/events/attendance",
  },
  { prefix: "/events/calendar", slug: "mimber-organization/events/calendar" },
  { prefix: "/events/create", slug: "mimber-organization/events" },
  { prefix: "/events/volunteering", slug: "mimber-organization/events" },
  { prefix: "/events/", slug: "mimber-organization/events/event-details" },
  { prefix: "/events", slug: "mimber-organization/events" },

  // Members
  {
    prefix: "/members/directory",
    slug: "mimber-organization/members/directory",
  },
  {
    prefix: "/members/groups-committees",
    slug: "mimber-organization/members/groups-and-committees",
  },
  { prefix: "/members/invites", slug: "mimber-organization/members/invites" },
  {
    prefix: "/members/membership-tiers",
    slug: "mimber-organization/members/membership-tiers",
  },
  { prefix: "/members/", slug: "mimber-organization/members/member-profile" },
  { prefix: "/members", slug: "mimber-organization/members" },

  // Finance
  {
    prefix: "/finance/donations",
    slug: "mimber-organization/finance/donations",
  },
  { prefix: "/finance/dues", slug: "mimber-organization/finance/dues" },
  {
    prefix: "/finance/invoices/",
    slug: "mimber-organization/finance/invoice-details",
  },
  { prefix: "/finance/invoices", slug: "mimber-organization/finance/invoices" },
  { prefix: "/finance/overview", slug: "mimber-organization/finance/overview" },
  { prefix: "/finance/reports", slug: "mimber-organization/finance/reports" },
  {
    prefix: "/finance/transactions",
    slug: "mimber-organization/finance/transactions",
  },
  { prefix: "/finance", slug: "mimber-organization/finance" },

  // Dashboard
  {
    prefix: "/dashboard/calendar",
    slug: "mimber-organization/dashboard/calendar",
  },
  {
    prefix: "/dashboard/overview",
    slug: "mimber-organization/dashboard/overview",
  },
  {
    prefix: "/dashboard/recent-activity",
    slug: "mimber-organization/dashboard/recent-activity",
  },
  { prefix: "/dashboard", slug: "mimber-organization/dashboard" },
]

/**
 * Resolves the docs slug for a given pathname, falling back to the docs
 * home page (empty slug) when no mapping is found.
 */
export const resolveDocsSlug = (pathname: string): string => {
  const match = ROUTE_TO_DOCS_SLUG.find(({ prefix }) =>
    pathname.startsWith(prefix)
  )
  return match?.slug ?? ""
}
